import { getSearchParam } from "./functions";
import ajaxFilter from "./ajax/ajaxFilter";
import ajaxPagination from "./ajax/ajaxPagination";

const shopProductsFilter = () => {
  $(() => {
    const searchParam = getSearchParam(),
      archiveLoopSection = document.getElementById("archive-loop-section"),
      archiveSelect = document.getElementById("archive-select");

    if (archiveLoopSection) {
      if (!searchParam) {
        if (archiveSelect) {

          const totalPages = document.querySelector('.archive-post:last-of-type').dataset.page
          ajaxPagination(totalPages)

          // Filter List
          archiveSelect.addEventListener("change", () => {
            ajaxFilter({
              tax: archiveSelect.value,
              search: "",
            });
          });
        } else {
          // Init List without Categories
          ajaxFilter({
            tax: "all",
            search: "",
          });
        }
      } else {
        // Filter by Search
        ajaxFilter({
          search: searchParam,
        });
      }
    }
  });
};

export default shopProductsFilter;
